import numeral from "numeral";

export const formatPrice = (price) => {
  let format = price%1 === 0 ? "$0,0" : "$0,0.00"
  return numeral(price).format(format);
};
